import type { PartialMessages } from "../messages";

export const ptBR: PartialMessages = {
  "status.syncing": "Sincronizado", "status.connecting": "Conectando", "status.full": "Cheio", "status.closed": "Desconectado",
  "toast.connecting": "Conectando…", "toast.reconnecting": "Conexão perdida. Tentando de novo…",
  "toast.retrying": "Vamos tentar de novo em instantes.", "toast.busy": "Está bem cheio agora",
  "notice.mapChanged": "{name} trocou o mapa",
  "hint.place": "Clique para colocar, arraste para apontar (Esc cancela)",
  "kind.objective": "Objetivo", "kind.rally": "Reunião", "kind.enemy": "Inimigo", "kind.loot": "Loot",
  "kind.extract": "Extração", "kind.danger": "Perigo", "kind.self": "Eu", "kind.ping": "Aqui!",
  "hint.objective": "Para onde vocês vão", "hint.rally": "Ponto de encontro",
  "hint.enemy": "Aponte para onde você o viu", "hint.loot": "Contêineres raros, corpos",
  "hint.extract": "A extração planejada", "hint.danger": "Minas, snipers, área aberta",
  "hint.self": "Sua posição. Colocar de novo apaga a anterior",
  "hint.ping": "Marca temporária que some depois de 25 segundos",
  "tool.clearMine": "Limpar os meus", "tool.clearMineHint": "Remove todas as marcas que você colocou",
  "sidebar.map": "Mapa (para todos)", "sidebar.styleSvg": "Ilustrado", "sidebar.styleTile": "Satélite",
  "sidebar.floors": "Andar (muda só a sua visão)", "sidebar.groundFloor": "Térreo",
  "sidebar.floorNote": "Marcas em outros andares aparecem apagadas.",
  "sidebar.members": "{count} na sala", "sidebar.you": "você", "sidebar.guest": "convidado",
  "sidebar.clearAll": "Limpar todas as marcas", "sidebar.openWindow": "Abrir em uma janela (só eu)",
  "sidebar.invite": "Convidar alguém", "sidebar.help": "Como usar", "sidebar.feedback": "Enviar feedback",
  "sidebar.mapData": "Dados do mapa", "sidebar.license": "Licença", "sidebar.licenseNote": "somente uso não comercial",
  "sidebar.room": "Sala",
  "pin.facing": "Direção", "pin.floor": "Andar", "pin.map": "Mapa", "pin.noFacing": "Sem direção",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Escreva uma nota (ex.: janela do terceiro andar)",
  "pin.removeMine": "Apagar esta marca", "pin.removeOther": "Apagar a marca de outra pessoa",
  "pin.close": "Fechar",
  "compass.n": "N", "compass.ne": "NE", "compass.e": "L", "compass.se": "SE",
  "compass.s": "S", "compass.sw": "SO", "compass.w": "O", "compass.nw": "NO",
  "handoff.title": "Abrir em uma janela",
  "handoff.lede": "Um link para você. Abre a mesma sala no navegador, para o Discord continuar mostrando a transmissão enquanto o mapa fica em outra tela.",
  "handoff.open": "Abrir no navegador deste computador", "handoff.or": "Em outro dispositivo",
  "handoff.codeHint": "Nesse aparelho, acesse {host}/j/ e digite o código acima.",
  "handoff.copy": "Copiar link", "handoff.copied": "Copiado",
  "handoff.copyFailed": "Selecionado acima — aperte Ctrl+C",
  "handoff.expiry": "Este link funciona uma vez só. Expira em {time}.",
  "handoff.warn": "Não repasse: abrir já gasta o link. Para isso use “Convidar alguém”.",
  "handoff.creating": "Criando o link…", "handoff.failed": "Não deu para criar o link",
  "invite.title": "Convidar alguém",
  "invite.lede": "Traga alguém que não está no canal de voz. A pessoa escreve um nome e já pode colocar marcas.",
  "invite.copy": "Copiar link", "invite.warn": "Qualquer um com este link entra. Não poste em público.",
  "invite.budget": "Mais {left} pessoas, expira em {time} (usado {used}/{max}).",
  "invite.revoke": "Revogar este link agora", "invite.revoked": "Link revogado.",
  "invite.creating": "Criando o link…", "invite.failed": "Não deu para criar o link",
  "invite.revokeFailed": "Não deu para revogar",
  "join.title": "Entrar no mapa",
  "join.lede": "Você foi convidado para o mapa de um raid. Escolha um nome; ele vai aparecer nas suas marcas.",
  "join.name": "Nome", "join.go": "Entrar", "join.joining": "Entrando…", "join.failed": "Não deu para entrar",
  "feedback.title": "Falar com o autor", "feedback.request": "Sugestão", "feedback.bug": "Problema",
  "feedback.other": "Outro", "feedback.requestHint": "Seria bom se…",
  "feedback.bugHint": "Tem algo errado", "feedback.otherHint": "Qualquer coisa",
  "feedback.placeholder": "ex.: queria traçar linhas, não só setas / no Streets os andares não trocam",
  "feedback.note": "Seu nome no Discord e seu ID vão junto, para podermos responder.",
  "feedback.send": "Enviar", "feedback.sending": "Enviando…", "feedback.sent": "Enviado. Valeu!",
  "feedback.failed": "Não deu para enviar",
  "time.minutes": "{n} min", "time.hoursMinutes": "{h} h {m} min",
  "error.roomFull": "Esta sala está cheia",
  "error.tooManyWindows": "Janelas demais abertas nesta sala. Feche uma.",
  "error.serverFull": "O servidor está cheio", "error.session": "Sua sessão não vale mais. Abra de novo.",
  "error.handoffSpent": "Esse link não funciona. Ele é de uso único e só para quem criou. Para chamar alguém, crie um link de convite pelo mapa.",
  "error.inviteSpent": "Este convite não vale mais. Peça um link novo.",
  "error.inviteNotOwner": "Só quem criou o link pode revogar",
  "error.noRoom": "Nenhuma sala informada", "error.needName": "Escreva um nome",
  "error.tooShort": "Escreva um pouco mais", "error.tooLong": "Está longo demais",
  "error.badKind": "Categoria inválida",
  "error.rateLimited": "Mensagens demais. Espere uns 10 minutos.",
  "error.busy": "Está cheio agora. Tente de novo daqui a pouco.",
  "error.sendFailed": "Não deu para enviar. Tente mais tarde.",
  "error.feedbackClosed": "O envio está fechado no momento",
  "error.sessionGone": "A sessão original acabou. Abra a atividade de novo.",
  "landing.tagline1": "Compartilhe um mapa de Tarkov",
  "landing.tagline2": "com todo mundo na call do Discord e expliquem juntos.",
  "landing.install": "Adicionar ao Discord",
  "landing.installNote": "De graça. Abre pelo ícone do foguete num canal de voz.",
  "landing.body": "Todo mundo na call vê o mesmo mapa. Um clique põe uma marca e, arrastando, ela ganha uma seta de direção — dá para mostrar não só onde, mas para onde.",
  "landing.point1": "Basta estar na mesma call. Sem código para digitar",
  "landing.point2": "Todos os 13 mapas. Ilustrado ou satélite, e os andares",
  "landing.point3": "As marcas ficam lá, dá para consultar depois",
  "landing.point4": "Quem não está na call entra por um link de convite",
  "landing.footNote": "Nunca encosta no jogo. Nada de arquivos, de memória, nada desenhado por cima. Cada marca é colocada à mão.",
  "landing.footCredit": "Projeto de hobby, rodando de graça. Dados de mapa do {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov é um produto da Battlestate Games Limited; isto é um projeto de fã não oficial, sem ligação com eles.",
  "landing.updates": "Novidades", "landing.allUpdates": "Todas as novidades",
  "boot.connecting": "Conectando ao Discord…", "boot.failedTitle": "Não deu para iniciar",
};
